import {otsBaseApi} from "../../ots-api";
import {PipelineGraphEdge} from "../../../model/pipeline/pipeline-graph-edge";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["PipelineGraphEdges"]});

const pipelineGraphEdgeApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllPipelineGraphEdges: builder.query<PipelineGraphEdge[], string | undefined>({
      query: (regionId) => ({
        url: `/pipeline-graph-edge/all`,
        method: "GET",
      }),
      keepUnusedDataFor: 300,
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "PipelineGraphEdges", id} as const)),
            {type: "PipelineGraphEdges", id: "LIST"}
          ];
        } else {
          return [{type: "PipelineGraphEdges", id: "LIST"}];
        }
      }
    }),
    getPipelineGraphEdge: builder.query<PipelineGraphEdge, string>({
      query: (id) => ({
        url: `/pipeline-graph-edge/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "PipelineGraphEdges", id}]
    }),
    createPipelineGraphEdge: builder.mutation<PipelineGraphEdge, Partial<PipelineGraphEdge>>({
      query: (mapping) => ({
        url: "/pipeline-graph-edge",
        method: "POST",
        body: mapping
      }),
      invalidatesTags: [{type: "PipelineGraphEdges", id: "LIST"}]
    }),
    updatePipelineGraphEdge: builder.mutation<PipelineGraphEdge, Partial<PipelineGraphEdge>>({
      query: (mapping) => ({
        url: "/pipeline-graph-edge",
        method: "PUT",
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [{type: "PipelineGraphEdges", id}]
    }),
    deletePipelineGraphEdge: builder.mutation<void, Partial<PipelineGraphEdge>>({
      query: (mapping) => ({
        url: "/pipeline-graph-edge",
        method: "DELETE",
        body: mapping
      }),
      invalidatesTags: (result, error, {id}) => [{type: "PipelineGraphEdges", id}]
    })
  })
});

export const {
  useGetAllPipelineGraphEdgesQuery,
  useGetPipelineGraphEdgeQuery,
  useCreatePipelineGraphEdgeMutation,
  useUpdatePipelineGraphEdgeMutation,
  useDeletePipelineGraphEdgeMutation,
} = pipelineGraphEdgeApi;
